
import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { SortedTableClass, ISort, StoreLoader, TableRowEmptyComponent, LoaderSpinnerComponent } from '@aston/foundation';
import { ListActionHandler } from 'apps/middle/src/app/shared-module/handlers';
import { AsyncPipe, NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { importColumnMapping, shouldHaveErrorsExpandedLines } from '../../functions';
import { ImportDateFormat, ImportReportErrorColumnsListSortProp, ImportReportErrorLinesListSortProp } from '../../enums';
import { IImportItem, IImportErrorColumnRowModel, IImportReportActions, IImportReportSelectors } from '../../models';
import { ImportReportErrorsListTableRowComponent } from '../import-report-errors-list-table-row/import-report-errors-list-table-row.component';
import { ImportReportErrorsListTableLineComponent } from '../import-report-errors-list-table-lines/import-report-errors-list-table-lines.component';

@Component({
	selector: 'import-report-errors-list-table',
	templateUrl: './import-report-errors-list-table.component.html',
	imports: [
		AsyncPipe,
		TranslateModule,
		ImportReportErrorsListTableRowComponent,
		TableRowEmptyComponent,
		LoaderSpinnerComponent,
		ImportReportErrorsListTableLineComponent,
		NgClass,
	]
})
export class ImportReportErrorsListTableComponent extends SortedTableClass<IImportErrorColumnRowModel, ImportReportErrorColumnsListSortProp> implements OnInit {
	private store = inject(Store);

	@Input() currentImport: IImportItem;
	@Input() currentImportLoader = StoreLoader.empty();
	@Input() disabled: boolean;
	@Input() actions: IImportReportActions;
	@Input() selectors: IImportReportSelectors;
	@Output() toggleRow = new EventEmitter<IImportErrorColumnRowModel>();
	listHandler: ListActionHandler;

	dateFormats = Object.entries(ImportDateFormat);

	listLoader = StoreLoader.empty();

	sortCols = ImportReportErrorColumnsListSortProp;

	ngOnInit() {
		this.listLoader = new StoreLoader(
			this.selectors.selectErrorColumnsListIsLoading,
			this.selectors.selectErrorColumnsListError)

		this.listHandler = new ListActionHandler()
			.withPagingDispatcher(this.dispatchPagingAction.bind(this));
	}

	hasErrorReportLine = (row: IImportErrorColumnRowModel) => shouldHaveErrorsExpandedLines(row)

	dispatchPagingAction(props) {
		this.store.dispatch(this.actions.UpdateColumnsSettings(props));
	}

	onValidate() {
		// keep me ?
	}

	onToggle(column: IImportErrorColumnRowModel) {
		if (!this.hasErrorReportLine(column)) return;

		this.store.dispatch(this.actions.ToggleLine({ column, loadLines: !column.isReportErrorLineListOpened }));
	}

	setLinesSort(data: { column: IImportErrorColumnRowModel, sort: ISort<ImportReportErrorLinesListSortProp> }) {
		this.store.dispatch(this.actions.UpdateLinesSettings({
			column: data.column, paging: { sorts: [data.sort] }
		}));
	}

	columnMapping(column: string): string {
		return importColumnMapping(column, this.currentImport.columnsMapping);
	}
}
